export const colorRed = '#e40040';
export const colorMediumGray = '#333';
export const colorBlack = '#000';
export const colorWhite = '#fff';

export const colorPrimary = colorRed;

export const mixinButton = () => `
    background: ${colorPrimary};
    display: block;
    width: 100%;
    padding: 0.3rem 0.8rem;
    color: ${colorWhite};
    border: none;
    text-align: center;
`;

export const breakpointMedium = `@media only screen and (min-width: 481px)`;
export const breakpointMediumOnly = `@media only screen and (min-width: 481px) and (max-width: 1279px)`;
export const breakpointLarge = `@media only screen and (min-width: 1280px)`;
export const breakpointExtraLarge = `@media only screen and (min-width: 1800px)`;
